<!--
  Copyright (C) 2022 - Jeci SARL - https://jeci.fr

  This program is free software: you can redistribute it and/or modify
  it under the terms of the GNU Affero General Public License as
  published by the Free Software Foundation, either version 3 of the
  License, or (at your option) any later version.

  This program is distributed in the hope that it will be useful,
  but WITHOUT ANY WARRANTY; without even the implied warranty of
  MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
  GNU Affero General Public License for more details.

  You should have received a copy of the GNU Affero General Public License
  along with this program.  If not, see https://www.gnu.org/licenses/agpl-3.0.html.
-->

<template>
  <div class="field-label">
    <label :for="forId" class="field-label-inner">
      <span>{{ label }}</span>
      <i
        v-if="help"
        v-tooltip.bottom="help"
        class="ri-information-line help-icon"
      ></i>
    </label>
    <small v-if="example" class="field-example">
      {{ $t("dashboardAdmin.blockEditor.example") }}: {{ example }}
    </small>
  </div>
</template>

<script>
export default {
  name: "FieldLabel",
  props: {
    label: {
      type: String,
      required: true,
    },
    forId: {
      type: String,
      default: "",
    },
    help: {
      type: String,
      default: "",
    },
    example: {
      type: String,
      default: "",
    },
  },
};
</script>

<style scoped>
.field-label label {
  display: flex;
  margin-bottom: 0.5rem;
  font-weight: 600;
  color: var(--p-text-color);
}

.field-label-inner {
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.help-icon {
  font-size: 1rem;
  color: var(--p-text-muted-color);
  cursor: help;
}

.field-example {
  color: var(--p-text-muted-color);
  display: block;
  margin-top: 0.25rem;
}
</style>
